import { StaffModel } from "states/staff/staff.models";

export interface ChangePasswordModel {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ForgotPasswordModel {
  email: string;
  appPath: string;
}
export interface ResetPasswordModel {
  userId: string;
  token: string;
  newPassword: string;
  confirmPassword: string;
}

export interface AccountState {
  currentUser?: CurrentUser;
  isAuthentication?: boolean;
  token: LoginResponse;
  currentStaff?: StaffModel;
}

export interface LoginResponse {
  accessToken?: string;
  refreshToken?: string;
  accessTokenExpires?: Date;
  refreshTokenExpires?: Date;
}

export interface CurrentUser {
  lockoutEnd?: string;
  phoneNumberConfirmed?: boolean;
  phoneNumber?: string;
  emailConfirmed?: false;
  normalizedEmail?: string;
  email?: string;
  normalizedUserName?: string;
  userName?: string;
  id: string;
  accessFailedCount?: number;
  roles: { id: string; name: string }[];
  permissions: { id: string; name: string; groupName: string }[];
}
export function isAdmin(currentUser: CurrentUser): boolean {
  return currentUser.roles.filter((m) => m.name === "Admin").length > 0;
}
export function isHavePermission(
  currentUser: CurrentUser,
  ...permissionName: string[]
): boolean {
  return (
    currentUser.permissions.filter((m) => permissionName.includes(m.name))
      .length > 0
  );
}

export interface LoginUserModel {
  userName: string;
  password: string;
}
